export default {
  title: {
    en: 'Thank you for your order',
  },
  text: {
    en: 'Your account has been upgraded.',
  },
  titleDetailed: {
    en: 'Thanks for upgrading!',
  },
  faqText: {
    en: `
      If you have questions please read our
      <Link className="brand" redirect="https://scentbird.zendesk.com/hc/en-us">FAQ</Link>
    `,
  },
}
